import React from 'react'
import AppLayout from '../../layout/components/AppLayout'
import ChatBotComponent from '../components/chat/ChatBotComponent'

function ChatBotPage() {
  return (
    <AppLayout>
        <ChatBotComponent></ChatBotComponent>
    </AppLayout>
  )
}

export default ChatBotPage